module.exports = __webpack_public_path__ + "cc04f3c302d0e041d09463742055a6d2.pdf";